import { Suspense } from "react";
import { Outlet } from "react-router";
import { Sidebar } from "@/components/layout/Sidebar";

export default function DashboardLayout() {
  return (
    <div className="flex h-screen overflow-hidden">
      <Sidebar />
      <main className="flex-1 overflow-y-auto">
        <div className="p-6 max-w-7xl mx-auto">
          <Suspense fallback={<div className="p-8 text-center text-muted-foreground">Načítám...</div>}>
            <Outlet />
          </Suspense>
        </div>
      </main>
    </div>
  );
}
